// src/routes.js
import React from 'react'
import QRCodeGenerator from 'qrcode.react'

const QRCode = ({ value, size, bgColor, fgColor }) => (
  <QRCodeGenerator
    value={value}
    size={size}
    bgColor={bgColor}
    fgColor={fgColor}
  />
)

export default QRCode



// WEBPACK FOOTER //
// ./src/components/common/QRCode/QRCode.js